// extracted by mini-css-extract-plugin
export default {"appIcon":"j7l4fk0w","appEntry":"x7RxRXye","appName":"iJukNrJh"};